import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './common/services/analytics.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit {
  
  title = 'api-explorer-frontend-app';
  theme: string = 'dark-mode';
 
  loggedIn = false;
  
  constructor( private analyticsService: AnalyticsService ) {}

  ngOnInit(): void {
    this.analyticsService.loadFullstory();
  }
  
}
